<template>
  <div class="layout">
    <Layout>
      <Header>
        <Navbar />
      </Header>
      <Content 
        :style="{padding: '0 50px'}"
      >
        <Breadcrumb 
          :style="{margin: '20px 0'}"
        >
          <BreadcrumbItem>
            Home
          </BreadcrumbItem>
          <BreadcrumbItem>
            {{ getPostContent.author }}
          </BreadcrumbItem>
          <BreadcrumbItem>
            {{ getPostContent.category }}
          </BreadcrumbItem>
        </Breadcrumb>
        <H1>
          {{ getPostContent.title }}
        </H1>
        <Card>
          <div style="min-height: 200px">
            <Row>
              <Col 
                span="18"
              >
              <span 
                v-html="getPostImg"
              />
              </Col>
              <Col 
                span="6"
              >
              <CellGroup>
                <Cell 
                  title="Price: 300HBD" 
                />
                <Cell 
                  title="Information of Interest" 
                />
                <Cell
                  title="User:"
                  :label="getPostContent.author"
                />
              </CellGroup>
              </Col>
            </Row>
            <Row>
              <Tabs>
                <TabPane 
                  label="Overview" 
                  icon="ios-book"
                >
                  <span 
                    v-html="getPostHtml" 
                    ref="content" 
                  />
                </TabPane>
                <TabPane 
                  label="Specifitations" 
                  icon="ios-list-box"
                >
                  Specifitations
                </TabPane>
                <TabPane 
                  label="Reviews" 
                  icon="ios-text"
                >
                  Reviews
                </TabPane>
              </Tabs>
            </Row>
          </div>
        </Card>
      </Content>
      <Footer class="layout-footer-center">
        2020 Hi2Peer
      </Footer>
    </Layout>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue"

export default {
  components: {
    Navbar
  },
  data() {
    return {
      html: '',
      tagImg: ''
    }
  },
  computed: {
    isLoad() {
      return this.$store.getters.isLoad
    },
    getPostBody() {
      return this.$store.getters.postContent.body
    },
    getPostHtml() {
      return this.$store.getters.postHtml
    },
    getPostImg() {
      return this.$store.getters.postImg[0]
    },
    getPostContent() {
      return this.$store.getters.postContent
    }
  },
  created() {
        let postList = {
      author: this.$route.params.author,
      permlink: this.$route.params.permlink
    }
    this.$store.dispatch("getPostContent", postList)
  }
}
</script>
<style>
.ivu-cell-label {
    font-size: 16px !important;
}
</style>
